import { useState } from "react";
import { Link2, Mail, Check } from "lucide-react";

export default function ShareRow({ title, excerpt }) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };

  const mailto = `mailto:?subject=${encodeURIComponent(`${title} — ELA Rituals Journal`)}&body=${encodeURIComponent(`${excerpt}\n\n${url}`)}`;
  const item = "inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-charcoal/55 hover:text-forest transition-colors link-underline";

  return (
    <div className="flex flex-wrap items-center gap-x-8 gap-y-3" data-testid="share-row">
      <span className="text-[11px] uppercase tracking-[0.22em] text-champagne">Share this article</span>
      <button type="button" onClick={copy} className={item} data-testid="share-copy-link" aria-live="polite">
        {copied ? <Check size={14} strokeWidth={1.5} /> : <Link2 size={14} strokeWidth={1.5} />}
        {copied ? "Link copied" : "Copy link"}
      </button>
      <a href={mailto} className={item} data-testid="share-email">
        <Mail size={14} strokeWidth={1.5} /> Email
      </a>
    </div>
  );
}
